import { getInheritedPropsForEditQuestion, getDomainConceptsMap } from 'Modules/Studio/helpers';

export const getNodesMapAndSuperclasses = (domains) => {
  let maps = { conceptsMap: {}, superClassMap: {} };
  try {
    maps = getDomainConceptsMap(domains);
  } catch (error) {
    console.error('Error while getting concepts map:', error);
  }

  const conceptsMap = maps.conceptsMap;

  const nodesMap = domains.reduce((acc, domain) => {
    return {
      ...acc,
      ...domain.concepts.reduce((accConcept, concept) => {
        let inherited = {
          properties: [],
          relations: [],
        };
        try {
          inherited = getInheritedPropsForEditQuestion(concept.inheritedConcepts, conceptsMap, {
            properties: [],
            relations: [],
          });
        } catch (error) {
          console.error(
            `Error while getting inherited properties for concept ${concept.uri}:`,
            error
          );
        }

        const all = {
          properties: [
            ...concept.properties.map((prop) => ({ ...prop, isRelation: false })),
            ...inherited.properties.map((prop) => ({ ...prop, isRelation: false })),
            ...concept.relations.map((rel) => ({ ...rel, isRelation: true })),
            ...inherited.relations.map((rel) => ({ ...rel, isRelation: true })),
          ],
          relations: [...concept.relations, ...inherited.relations],
        };

        return {
          ...accConcept,
          [concept.uri]: {
            ...concept,
            domainColor: domain.color,
            domainName: domain.name,
            domainUri: domain.uri,
            properties: all.properties,
            relations: all.relations.reduce(
              (relAcc, rel) => ({
                ...relAcc,
                [rel.label]: rel,
              }),
              {}
            ),
          },
        };
      }, {}),
    };
  }, {});

  return { nodesMap, superClassMap: maps.superClassMap, conceptsMap: maps.conceptsMap };
};
